import { useState } from 'react'

export const usePositiveNumberState = (initialValue: number, fallbackValue: number = 1) => {
   
   const validatedInitial = initialValue > 0 ? initialValue : fallbackValue
   const [value, setValue] = useState<number>(validatedInitial)
   
   const setValidatedValue = (newValue: number) => {
      setValue(newValue > 0 ? newValue : fallbackValue)
   }

  return [value, setValidatedValue] as const
}